// @flow
import {
    INITIAL_CHECK_FOR_PUBLICATION_CHANGES_COMPLETE,
    ERROR_QUERYING_NOTIFICATIONS,
    QUERYING_NOTIFICATIONS,
    RECEIVED_NOTIFICATIONS
} from "../constants";

import loadNotifications_thunk from "./thunks/loadNotifications";
import getNotifications_thunk from "./thunks/getNotifications";
import clearAllNotifications_thunk from "./thunks/clearAllNotifications";
import dismissNotification_thunk from "./thunks/dismissNotification";
import markNotificationAsRead_thunk from "./thunks/markNotificationAsRead";


export const ErrorQueryingNotifications = (errorMessage) => ({
    type: ERROR_QUERYING_NOTIFICATIONS,
    errorMessage
});

export const NotificationsReceived = (notifications) => ({
    type: RECEIVED_NOTIFICATIONS,
    notifications
});

export const QueryingNotifications = () => ({
    type: QUERYING_NOTIFICATIONS
});

export const InitialPublicationCheckComplete = () => ({
    type: INITIAL_CHECK_FOR_PUBLICATION_CHANGES_COMPLETE
});

export const LoadNotifications = loadNotifications_thunk;
export const GetNotifications = getNotifications_thunk;
export const ClearAllNotifications = clearAllNotifications_thunk;
export const DismissNotification = dismissNotification_thunk;
export const MarkNotificationAsRead = markNotificationAsRead_thunk;